/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ signal: NonNullable<unknown> }} Automation_Signal_LabelInputs */

const en_automation_signal_label = /** @type {(inputs: Automation_Signal_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.signal === "task.created") return /** @type {LocalizedString} */ (`Task created`);
	if (i?.signal === "task.assigned") return /** @type {LocalizedString} */ (`Task assigned`);
	if (i?.signal === "task.completed") return /** @type {LocalizedString} */ (`Task completed`);
	if (i?.signal === "case.step_changed") return /** @type {LocalizedString} */ (`Case step changed`);
	if (i?.signal === "case.requirements_blocked") return /** @type {LocalizedString} */ (`Case requirements pending`);
	if (i?.signal === "case.requirements_ready") return /** @type {LocalizedString} */ (`Case requirements ready`);
	if (i?.signal === "client.status_changed") return /** @type {LocalizedString} */ (`Client status changed`);
	if (i?.signal === "document.uploaded") return /** @type {LocalizedString} */ (`Document uploaded`);
	if (i?.signal === "document.classified") return /** @type {LocalizedString} */ (`Document classified`);
	return /** @type {LocalizedString} */ (`${i?.signal}`)
	
};

const pt_br2_automation_signal_label = /** @type {(inputs: Automation_Signal_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.signal === "task.created") return /** @type {LocalizedString} */ (`Tarefa criada`);
	if (i?.signal === "task.assigned") return /** @type {LocalizedString} */ (`Tarefa atribuída`);
	if (i?.signal === "task.completed") return /** @type {LocalizedString} */ (`Tarefa concluída`);
	if (i?.signal === "case.step_changed") return /** @type {LocalizedString} */ (`Etapa do caso alterada`);
	if (i?.signal === "case.requirements_blocked") return /** @type {LocalizedString} */ (`Requisitos do caso pendentes`);
	if (i?.signal === "case.requirements_ready") return /** @type {LocalizedString} */ (`Requisitos do caso prontos`);
	if (i?.signal === "client.status_changed") return /** @type {LocalizedString} */ (`Status do cliente alterado`);
	if (i?.signal === "document.uploaded") return /** @type {LocalizedString} */ (`Documento enviado`);
	if (i?.signal === "document.classified") return /** @type {LocalizedString} */ (`Documento classificado`);
	return /** @type {LocalizedString} */ (`${i?.signal}`)
	
};

/**
* | signal | output |
* | --- | --- |
* | "task.created" | "Task created" |
* | "task.assigned" | "Task assigned" |
* | "task.completed" | "Task completed" |
* | "case.step_changed" | "Case step changed" |
* | "case.requirements_blocked" | "Case requirements pending" |
* | "case.requirements_ready" | "Case requirements ready" |
* | "client.status_changed" | "Client status changed" |
* | "document.uploaded" | "Document uploaded" |
* | "document.classified" | "Document classified" |
* | * | "{signal}" |
*
* @param {Automation_Signal_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_signal_label = /** @type {((inputs: Automation_Signal_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Signal_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_signal_label(inputs)
	return pt_br2_automation_signal_label(inputs)
});